/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_discount_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35% off 140: you save 49, final price 91.`)
};

const es_pct_discount_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35% de descuento sobre 140: ahorras 49, precio final 91.`)
};

const de_pct_discount_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35% Rabatt auf 140: du sparst 49, Endpreis 91.`)
};

const nl_pct_discount_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35% korting op 140: je bespaart 49, eindprijs 91.`)
};

const fr_pct_discount_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35 % de réduction sur 140 : vous économisez 49, prix final 91.`)
};

const it_pct_discount_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35% di sconto su 140: risparmi 49, prezzo finale 91.`)
};

const pt_br2_pct_discount_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35% de desconto em 140: você economiza 49, preço final 91.`)
};

const pt_pct_discount_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35% de desconto em 140: poupa 49, preço final 91.`)
};

const ja_pct_discount_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`140の35%オフ: 節約額49、最終価格91。`)
};

const zh_pct_discount_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`140 打 35% 折扣：节省 49，最终价格 91。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_discount_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_discount_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_discount_ex3", locale)
	if (locale === "en") return en_pct_discount_ex3(inputs)
	if (locale === "es") return es_pct_discount_ex3(inputs)
	if (locale === "de") return de_pct_discount_ex3(inputs)
	if (locale === "nl") return nl_pct_discount_ex3(inputs)
	if (locale === "fr") return fr_pct_discount_ex3(inputs)
	if (locale === "it") return it_pct_discount_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_pct_discount_ex3(inputs)
	if (locale === "pt") return pt_pct_discount_ex3(inputs)
	if (locale === "ja") return ja_pct_discount_ex3(inputs)
	return zh_pct_discount_ex3(inputs)
};